import { KEYWORD_DEBOUNCE_DELAY, MINIMAL_SEARCH_QUERY_LENGTH } from 'config/constants';
import useDebounce from 'hooks/helpers/UseDebounce';
import { useEffect, useRef } from 'react';
import { AutocompleteSearchType } from 'types/search';
import { useGtmContext } from 'utils/Gtm/context/GtmProvider';
import { getGtmSearchResultEvent } from 'utils/Gtm/EventFactories';
import { gtmSafePushEvent } from 'utils/Gtm/Gtm';

export const useGtmSearchResultView = (
    searchResult: AutocompleteSearchType | undefined,
    keyword: string,
    fetching: boolean,
): void => {
    const lastSearchedKeywordRef = useRef<string | null>(null);
    const debouncedKeyword = useDebounce(keyword, KEYWORD_DEBOUNCE_DELAY);
    const { didPageViewRun } = useGtmContext();

    useEffect(() => {
        if (
            didPageViewRun &&
            searchResult &&
            debouncedKeyword.length >= MINIMAL_SEARCH_QUERY_LENGTH &&
            lastSearchedKeywordRef.current !== debouncedKeyword &&
            !fetching
        ) {
            const event = getGtmSearchResultEvent(searchResult, debouncedKeyword);
            gtmSafePushEvent(event);
        }
    }, [debouncedKeyword, searchResult, fetching, didPageViewRun]);

    useEffect(() => {
        lastSearchedKeywordRef.current = debouncedKeyword;
    }, [debouncedKeyword]);
};
